<div class="copyright" [class.copyright--dark]="isDark()">
  <a class="copyright__link" target="_blank" rel="noopener noreferrer" [href]="helpAndSupportLink">
    {{ 'copyright.help' | translate }}
  </a>
  <div class="copyright__divider"></div>
  <span>
    {{ 'copyright.rights' | translate: { year: year } }}
  </span>
</div>
